import { SecureInformationRequestField } from './SecureInformationRequestField';
import {
  GroupsOnChangeHandler,
  IStateSecureInformationRequestField,
  IStateSecureInformationRequestGroup,
} from './types';

export const SecureInformationRequestGroup = ({
  group,
  onChange,
  companyId,
}: {
  group: IStateSecureInformationRequestGroup;
  companyId: number;
  onChange: GroupsOnChangeHandler;
}) => {
  return (
    <div className="p-2xl bg-bg-primary border rounded-xl flex flex-col gap-3xl">
      {group.headerText ? (
        <div className="txt-extra-large-bold">{group.headerText}</div>
      ) : null}
      <div className="flex flex-col justify-center gap-2xl">
        {group.fields
          .sort((a, b) => a.indexInGroup - b.indexInGroup)
          .map((field) => (
            <SecureInformationRequestField
              field={field as IStateSecureInformationRequestField}
              key={field.id}
              onChange={onChange}
              companyId={companyId}
            />
          ))}
      </div>
    </div>
  );
};
